// extracted by mini-css-extract-plugin
module.exports = {"navBar":"SearchBar_navBar__dh3fO","title":"SearchBar_title__BNuGS"};